import React, {useEffect, useState} from 'react';
import FilterWithSelectedOptions from './FilterWithSelectedOptions';

const Filter = ({
  filters,
  item,
  index,
  mode,
  search,
  setSelectedOptions,
  selectedOptions,
  deleteOption,
  isSearch = false,
}) => {
  const [currentFilters, setCurrentFilters] = useState([]);

  useEffect(() => {
    if (isSearch) return;
    setCurrentFilters(
      filters[item.value]?.map((op) => {
        //перевірка ID
        const isOnlyDigits =
          typeof op.id === 'number'
            ? op.id !== 0
            : typeof op.id === 'string' && /^\d+$/.test(op.id) && op.id !== '0';
        const baseName =
          op.name ||
          (op.first_name && op.last_name && `${op.first_name} ${op.last_name}`) ||
          op.username ||
          '';
        const label = isOnlyDigits ? `#${op.id} ${baseName}` : baseName;

        const obj = {
          value: op.id,
          label,
        };

        if (!!op?.withDateRange) obj.withDateRange = op?.withDateRange;

        if (op.flag) {
          obj.flag = op.flag;
        }

        return obj;
      })
    );
  }, []);

  const onChange = (e) => {
    const newSelectedOptions = JSON.parse(JSON.stringify(selectedOptions));
    newSelectedOptions[index].options = e;
    setSelectedOptions(newSelectedOptions);
  };

  const onChangeValue = (value) => {
    if (!isSearch) return;

    if (value.trim()) {
      setCurrentFilters([{value: value, label: `${value}`}]);
    } else {
      setCurrentFilters([]);
    }
  };

  return (
    <>
      <FilterWithSelectedOptions
        item={item}
        index={index}
        options={currentFilters}
        selectedOptions={selectedOptions[index].options || []}
        onChange={onChange}
        apply={search}
        onChangeValue={onChangeValue}
        isSearch={isSearch}
        del={deleteOption}
      />
    </>
  );
};

export default Filter;
